import { ComponentBaseProps } from '@ecdlink/ui';

export enum CaregiverChildRegistrationSteps {
  welcome = 0,
  registrationForm = 1,
  childExtraInformationForm = 2,
  childHealthInformationForm = 3,
  childBirthCertificateForm = 4,
  childCareGiverInformationForm = 5,
  childCareGiverChildInformationForm = 6,
  childCareGiverExtraInformationForm = 7,
  childCareGiverContributionForm = 8,
  childEmergencyContactForm = 9,
  careGiverReferencePanelForm = 10,
  outro = 11,
}
export interface CaregiverChildRegistrationProps extends ComponentBaseProps {
  childDetails: ChildRegistrationDetails;
  caregiverAuthToken: string;
}

export interface ChildRegistrationDetails {
  child: ChildDetails;
  practitoner: PractitionerDetails;
  accessToken: string;
}

export interface ChildDetails {
  firstname: string;
  surname: string;
  groupName: string;
  groupFeeAmount: number;
  userId?: string;
}

export interface PractitionerDetails {
  firstname: string;
  surname: string;
  phoneNumber: string;
}
